import { motion } from 'framer-motion'
const Header = ({ text, theme = 'black' }) => {
    return (
        <motion.h2
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
            viewport={{ once: true }}
            className={`block py-8 uppercase font-semibold text-lg ${theme === 'black' ? 'text-black' : 'text-white'}`}>
            <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-[#589EEE] inline-block rounded-full" />
                {text}
            </div>
        </motion.h2>
    )
}
export default Header